var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 56,
    viewBox: "0 0 59 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.4142 0C13.5561 0 0.698242 12.8291 0.698242 28.6519C0.698242 39.9523 7.25609 49.7202 16.7804 54.3835C17.0816 54.53 17.3846 54.6727 17.6896 54.8079C17.7912 54.853 17.8928 54.8943 17.9945 54.9375C18.2015 55.0258 18.4067 55.1159 18.6156 55.2004C18.7417 55.2512 18.8679 55.2981 18.994 55.3469C19.1822 55.4202 19.3685 55.4934 19.5587 55.5629C19.6942 55.6117 19.8335 55.6568 19.9709 55.7056C20.1384 55.7639 20.3059 55.824 20.4753 55.8803C20.4791 55.8822 20.4828 55.8822 20.4866 55.8822C20.5111 55.8897 20.5374 55.8991 20.5619 55.9085C20.9628 56.0381 21.375 55.747 21.375 55.3263V55.2361V51.341V39.6932C24.5335 39.5035 28.1155 38.9006 31.8349 37.8639C33.8188 37.3118 35.7029 36.6713 37.4572 35.9727V51.3391V55.2343V55.3244C37.4572 55.7451 37.8694 56.0362 38.2704 55.9066C38.2948 55.8991 38.3212 55.8897 38.3457 55.8803C38.3494 55.8784 38.3532 55.8784 38.3569 55.8784C38.5264 55.824 38.692 55.7639 38.8595 55.7056C38.9969 55.6587 39.1362 55.6136 39.2736 55.5629C39.4618 55.4953 39.6463 55.4202 39.8327 55.3488C39.9606 55.3 40.0886 55.253 40.2166 55.2004C40.4237 55.1159 40.6289 55.0277 40.834 54.9375C40.9357 54.8924 41.0411 54.8511 41.1427 54.8061C41.4495 54.669 41.7526 54.5281 42.0519 54.3816C51.5762 49.7165 58.134 39.9486 58.134 28.6501C58.1321 12.8291 45.2743 0 29.4142 0ZM16.7804 34.7895C15.4779 34.4834 14.6384 33.9519 14.4276 33.1969C14.1433 32.1827 15.0431 30.9244 16.7804 29.6361V34.7895ZM30.602 33.4504C27.2308 34.3895 24.0291 34.9266 21.3732 35.0656V27.0387C23.3477 26.1447 25.6403 25.3108 28.1287 24.6178C31.5412 23.6675 34.7787 23.1304 37.4535 22.9971V30.9845C35.4601 31.8954 33.1317 32.7443 30.602 33.4504ZM42.05 23.3032C43.296 23.6131 44.0998 24.1352 44.3049 24.8695C44.5835 25.8649 43.7252 27.095 42.05 28.359V23.3032ZM42.05 49.1437V33.8486C47.3335 31.0108 50.4581 27.711 49.7391 25.1399C49.165 23.0872 46.2512 21.9059 42.05 21.6655V16.7243C42.05 16.3487 41.745 16.0444 41.3686 16.0444H38.1348C37.7584 16.0444 37.4535 16.3487 37.4535 16.7243V21.7444C34.502 21.9829 31.2156 22.567 27.8143 23.5154C25.5179 24.1558 23.3533 24.9108 21.3713 25.7409V16.7243C21.3713 16.3487 21.0664 16.0444 20.6899 16.0444H17.4599C17.0835 16.0444 16.7785 16.3487 16.7785 16.7243V27.9852C11.9957 30.716 9.22872 33.8054 9.9101 36.2394C10.4466 38.155 13.0215 39.3119 16.7785 39.6518V49.1418C9.89316 44.9011 5.29288 37.3042 5.29288 28.6519C5.29288 15.3815 16.1141 4.58439 29.4142 4.58439C42.7144 4.58439 53.5375 15.3815 53.5375 28.6519C53.5375 37.3042 48.9372 44.9011 42.05 49.1437Z",
    fill: "url(#paint0_linear_1_422)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_422",
    x1: 29.4152,
    y1: 55.94,
    x2: 29.4152,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1243,
    stopColor: "#135E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1285,
    stopColor: "#1967A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    stopColor: "#3188BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1639,
    stopColor: "#44A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1824,
    stopColor: "#51B4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2017,
    stopColor: "#59BEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2233,
    stopColor: "#5CC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2722,
    stopColor: "#3B9FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3189,
    stopColor: "#1F8195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#218A94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#249994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5607,
    stopColor: "#25A293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7239,
    stopColor: "#26A593"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dc6a695d69a853cedac67cd9e258bb08.svg";
export { ForwardRef as ReactComponent };